import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import FormatAlignLeft from "@material-ui/icons/FormatAlignLeft";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

import sectionPillsStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionPillsStyle.js";

const useStyles = makeStyles((theme) => ({
  ...sectionPillsStyle,
  cardTitle: {
    fontSize: "1.2rem",
    fontWeight: 600,
    lineHeight: "1.4em",
    marginTop: "8px",
    marginBottom: "8px",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.95rem"
    }
  }
}));

const extractFirstTwoSentencesOfFirstParagraph = (html) => {
  const match = html.match(/<p[^>]*>(.*?)<\/p>/i);
  if (!match) return "";

  let paragraph = match[1].replace(/(<([^>]+)>)/gi, "").trim();
  const parser = new DOMParser();
  const decoded = parser.parseFromString(paragraph, "text/html").documentElement.textContent;

  const sentences = decoded
    .split(/(?<=[.!?])\s+/)
    .slice(0, 2)
    .join(" ");

  return sentences;
};

export default function SectionPills() {
  const classes = useStyles();
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState("Tümü");

  useEffect(() => {
    fetch("https://ecommerce24.pythonanywhere.com/api/blog/")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);
        const uniqueCategories = Array.from(
          new Set(data.map((post) => post.category?.name).filter(Boolean))
        );
        setCategories(uniqueCategories);
      });
  }, []);

  const filteredPosts =
    activeCategory === "Tümü"
      ? posts
      : posts.filter((post) => post.category?.name === activeCategory);

  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px" }}>
            <Button
              color={activeCategory === "Tümü" ? "primary" : "transparent"}
              round
              onClick={() => setActiveCategory("Tümü")}
            >
              Tümü
            </Button>
            {categories.map((cat) => (
              <Button
                key={cat}
                color={activeCategory === cat ? "primary" : "transparent"}
                round
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </Button>
            ))}
          </div>
          <div className={classes.tabSpace} />
        </GridItem>
      </GridContainer>

      <GridContainer>
        {filteredPosts.map((post, index) => (
          <GridItem xs={12} sm={6} md={6} key={index} style={{ marginBottom: "30px" }}>
            <Card
              raised
              background
              style={{
                position: "relative",
                backgroundImage: `url(${post.cover_image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "260px",
                maxHeight: "360px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                color: "#fff",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0))",
                  zIndex: 1,
                  borderRadius: "6px"
                }}
              />

              <CardBody
                background
                style={{
                  position: "relative",
                  zIndex: 2,
                  padding: "15px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  overflow: "hidden"
                }}
              >
                {post.category?.name && (
                  <h6 className={classes.category}>{post.category.name}</h6>
                )}
                <a href={`/blog-posts/${post.slug}`}>
                  <h3 className={classes.cardTitle}>{post.title}</h3>
                </a>
                <p className={classes.category}>
                  {extractFirstTwoSentencesOfFirstParagraph(post.content)}
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "auto",
                    minHeight: "40px",
                    flexShrink: 0
                  }}
                >
                  <Button round href={`/blog-posts/${post.slug}`} color="danger">
                    <FormatAlignLeft className={classes.icons} /> Yazıyı Oku
                  </Button>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        ))}
      </GridContainer>
    </div>
  );
}
